import { EXCLUDE_FROM_TIMESLIDER } from '../config/constants'
import lookupLayerIcon from '../utility/lookupLayerIcon'

const generateMarks = (allTimestamps, minTimestamp, maxTimestamp) => {
  const combinedTimestamps = Object.keys(allTimestamps)
    .filter(key => !EXCLUDE_FROM_TIMESLIDER.includes(key))
        .reduce((prev, next) => {
          const timestamps = allTimestamps[next]
          const timestampsFiltered = (minTimestamp && maxTimestamp)
                ? timestamps.filter(timestamp => timestamp >= minTimestamp && timestamp <= maxTimestamp)
                : timestamps
      return prev.concat(
        timestampsFiltered.map(timestamp => ({
          timestamp,
          layerName: next,
          timestampEpoch: new Date(timestamp).getTime()
        }))
      )
        }, [])

  const marks = combinedTimestamps.reduce((result, item, index, array) => {
    result[item.timestampEpoch] = {
      label: lookupLayerIcon(item.layerName),
      layerName: item.layerName,
      layerNames: (
        (result[item.timestampEpoch] &&
          result[item.timestampEpoch].layerNames) ||
        []
      )
        .slice()
        .concat(item.layerName),
      timestampEpoch: item.timestamp,
      timestamp: item.timestamp
    }
    return result
  }, {})
  return marks
}

export default generateMarks



// WEBPACK FOOTER //
// ./src/utility/generateMarks.js